import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { siteNamesRequest } from '../actions/spaces/SitesNamesRequestAction';
import { NavLocationSelectors } from '../selectors/NavigationStateSelectors';
import { SessionSiteSelectors, SessionUserSelectors } from '../selectors/SessionInfoSelectors';
import { selectSites } from '../selectors/SitesSelectors';
import { AppState } from '../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../utils/ConnectUtils';
import { SitePicker, SitePickerDispatchProps, SitePickerOwnProps, SitePickerStateProps } from './SitePicker';


const mapStateToProps: MapStateToProps<SitePickerStateProps> = (state: AppState) => ({
  currentSiteName: SessionSiteSelectors.siteName(state),
  sites: selectSites(state),
  inServerArea: NavLocationSelectors.inServerArea(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state)
});

const mapDispatchToProps: MapDispatchToProps<SitePickerDispatchProps> =
  (dispatch) => bindActionCreators({
    requestSites: siteNamesRequest
  },
  dispatch);

export const ConnectedSitePicker: React.ComponentClass<SitePickerOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(SitePicker);
